import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

// ------------------------------------------------------
export interface IInputControl {
  loading: boolean;
  disabled: boolean;
  error: string;
}

@Component({
  selector: 'smartinput',
  template: require('./smartinput.component.pug'),
  styles: [require('./smartinput.component.css').toString()],
})
export class SmartInputComponent implements OnInit {
  @Input('checked')
  checked: boolean;

  @Input()
  label: string = '';
  @Input()
  placeholder: string = '';
  @Input()
  icon: string = '';
  @Input()
  data: any;
  @Input()
  initialValue: any;
  @Input()
  change: onSmartInputCallback;
  @Input('controller')
  controller: IInputControl;
  @Input('confirm')
  confirm: boolean = false;
  @Input('extraclass')
  extraclass: string = '';
  @Input('disabled')
  disabled: boolean = false;
  @Input()
  password: boolean = false;
  @Input()
  detectParentValueChanges: boolean = false;
  @Input()
  checkBeforeChange: boolean = true;

  @Output()
  onValueChanged = new EventEmitter();

  error: string = '';
  hasError: boolean = false;
  loading: boolean = false;
  type = 'text';

  modelChanged: Subject<any> = new Subject<any>();

  // -------------------------------------------------------------------
  constructor() {
    this.modelChanged
      .pipe(debounceTime(1000), distinctUntilChanged((prev, curr) => this.checkBeforeChange && prev === curr))
      .subscribe(model => this.communicateChanges(model));
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    if (this.password) {
      this.type = 'password';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.detectParentValueChanges) return;

    if (Object.keys(changes).includes("initialValue") && changes.initialValue) {
      this.initialValue = changes.initialValue.currentValue;
    }
  }

  // -------------------------------------------------------------------
  getPlaceholder() {
    if (this.placeholder) {
      return this.placeholder;
    }

    return '';
  }

  // -------------------------------------------------------------------
  iconClass() {
    let newClass = {};
    newClass[this.icon] = true;
    newClass['text-info'] = this.called && !this.hasError;
    newClass['text-danger'] = this.hasError;
    return newClass;
  }

  // -------------------------------------------------------------------
  onSuccess() {
    if (this.onValueChanged) {
      this.onValueChanged.emit(this.initialValue);
    }
    this.loading = false;
  }

  // -------------------------------------------------------------------
  onFailure(error: string) {
    this.hasError = true;
    this.loading = false;
    this.error = error;
    // console.log('onFailure!');
  }

  called = false;

  // -------------------------------------------------------------------
  valueChanged(newvalue) {
    this.modelChanged.next(newvalue);
  }

  // -------------------------------------------------------------------
  communicateChanges(newvalue) {
    // console.warn(newvalue);
    if (this.loading) {
      return; // don't accept clicks in transition state
    }

    this.called = true;
    this.hasError = false;
    this.error = '';
    this.loading = true;
    this.initialValue = newvalue;

    this.change(
      this.data,
      newvalue,
      this.onSuccess.bind(this),
      this.onFailure.bind(this),
    );
  }
}
